import StopFeature from "@/services/maps/features/reports/stop.feature"
import DateUtil from "@/utils/date.util"
import DeviceUtil from "@/utils/device.util"
import dayjs from "dayjs";
import { Feature } from "ol"
import { Geometry } from "ol/geom"
import ReportStrategy from "./report.strategy"

export default class StoppageReportStrategy extends ReportStrategy {

    async getExtraFeatures(): Promise<Feature<Geometry>[]> {
        return this.getStoppingFeatures()
    }

    async getStoppingFeatures() {
        const features = []
        const minLimit = 1 //km/h
        const timeLimit = 2 //minutes
        let i1 = 0, i2 = 0, countStops = 0
        let flag1 = true, flag2 = true
        let start, end

        while (flag1) {
            if ((DeviceUtil.formatKnToKmh(this.data[i1].speed) <= minLimit)) {
                i2 = i1
                start = i1
                while (flag2) {
                    if (DeviceUtil.formatKnToKmh(this.data[i2].speed) > minLimit || i2 == this.data.length - 1) { //SI LA VELOCIDAD ES MAYOR QUE 1 O EL BUCLE LLEGA AL FIN DEL LISTADO
                        flag2 = false
                        end = i2
                        const diff = this.getStopTime(start, end)
                        if (diff > timeLimit) {
                            countStops++
                            features.push(await this.createStopFeature(start, end, diff, countStops))
                        }
                        i1 = i2
                    }
                    if (i2 == this.data.length - 1) flag2 = false
                    i2++
                }
                flag2 = true
            }
            if (i1 == this.data.length - 1) flag1 = false
            i1++
        }
        return features
    }

    getStopTime(start: number, end: number) {
        //TODO: ADD CASE FOR DIFERENT DATE
        const time1 = dayjs(this.data[start].deviceTime)
        const time2 = dayjs(this.data[end].deviceTime)
        return time2.diff(time1, 'minutes')
    }

    async createStopFeature(start: number, end: number, duration: number, index: number) {
        const latitude = this.data[start].latitude
        const longitude = this.data[start].longitude
        return new StopFeature({
            index,
            latitude,
            longitude,
            minutes: duration,
            duration: DateUtil.formatSeconds(duration * 60),
            endDate: DateUtil.getGenericFormat(this.data[end].deviceTime),
            startDate: DateUtil.getGenericFormat(this.data[start].deviceTime),
            report: this.report,
            title: 'PARADA ' + index,
        }).create()
    }
}